import { mapGetters, mapActions } from 'vuex';

import Spinner from '@/components/Spinner.vue';
import IMTeamAnnouncementComponent from '@/components/IMTeamAnnouncementComponent.vue';

export default {
  name: 'IMTeamAnnouncement',
  components: {
    Spinner,
    IMTeamAnnouncementComponent,
  },

  data: () => {
    return {
      documentTitle: '',
      // hasCookie: false,
    };
  },

  computed: {
    ...mapGetters({
      imTeamAnnouncementList: 'imTeamAnnouncementList',
    }),

    TeamId: function () {
      return this.$route.params.teamId;
    },
  },

  created() {
    this._getTeamAnnouncementByTeamId();
    this.documentTitle = document.title;
    document.title = '群公告';
  },

  beforeDestroy() {
    document.title = this.documentTitle;
  },

  methods: {
    // ...mapActions('getIMTeamAnnouncementByTeamId'),

    async _getTeamAnnouncementByTeamId() {
      console.log(this.TeamId);
      await this.$store.dispatch('getIMTeamAnnouncementByTeamId', this.TeamId);
      console.log(this.imTeamAnnouncementList);
    },
  },
};
